<template>
  <mw-dialog
    size="large_large"
    title="编辑附件"
    :footerButton="footerButton"
    ref="dialog"
    @opened="showUpload"
  >
    <div class="mw-toolbar">
      <el-select v-model="fileType" :placeholder="$lang('请选择')" style="width:100px;" >
        <el-option
          v-for="item in fileTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button ref="addAttachmentRef">添加</el-button>
    </div>
    <div class="mw-toolbar__body mw-app__edit" style="">
        <el-table height="100%"  :data="attachmentList" >
          <el-table-column label="序号" width="40"  prop="sn" />
          <el-table-column  label="名称" prop="name"  >
            <template slot-scope="scope" >
              <double-face>
                <span slot="readonly">{{  scope.row["name"] }}&nbsp;</span>
                <span slot="editable">
                  <el-input v-model="scope.row['name']" @change="rename(scope.row,scope.$index)"></el-input>
                </span>
              </double-face>
            </template>
          </el-table-column>
          <el-table-column label="大小" prop='size' width="100" />
          <el-table-column label="类型" prop='type'  width="60" >
            <template slot-scope="scope">
              <span>{{formatType(scope.row.type)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button  type="text"  size="small"  @click="download(scope.row)" >
                下载
              </el-button>
              <el-button :id="'uploader_'+scope.row.id" type="text" size="small"  @click="up(scope.row)"  >
                替换
              </el-button>
              <el-button  type="text"  size="small"  @click="deleteFile(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
  </mw-dialog>
</template>

<script>
  import DoubleFace from "@/modules/index/views/systemSet/modelManage/components/doubleface";
export default {
  data() {
    var fileTypes = window.$Env && $Env.efileTypes ? $Env.efileTypes :
        [{label:'正文',value:'JOA_ZW'},{label:'草稿',value:'JOA_CG'},{label:'附件',value:'JOA_FJ'},{label:'处理单',value:'JOA_CLD'}];

    return {
      footerButton: [
        {
          label: "关闭",
          func: () => {
            this.mwRef("dialog").hide();
          }
        }
      ],

      businessId: "",
      applicationId: "",
      moduleId: "",
      //formKey: "",
      formId: "",
      tempBusinessId: "",
      uploadUrl: `/cheetah/service/s:maintain.srv.replaceAttachment`,
      attachmentList: [],
      progressText:"",
      isFirstOpen:true,
      initAttachUploadedId : [],
      attchId:'',
      fileType:'JOA_FJ',
      fileTypes:fileTypes,
      type:'JOA_FJ'
    };
  },
  mounted() {
    let me=this;
  },
  watch: {},
  components: {
    DoubleFace
  },
  methods: {
    formatType(type){
       if(type=="JOA_ZW") return "正文";
       else if(type=='JOA_CG') return '草稿';
       else if(type=='JOA_CLD') return '处理单';
       else if(type=='JOA_FJ') return "附件";
       else return type;
    },
    showUpload(){
      if(this.isFirstOpen){
        this.$nextTick(function() {
          this.initAddUploader();
        })
        this.isFirstOpen=false;
      }
    },

    initAddUploader(){
      var me = this;
      let cfg={
        buttonId:this.$refs.addAttachmentRef.$el,
        maxSize:500,
        multi:false,
        action:this.mwUrl('/api/business/uploadAttachment')
      }
      let fn={
        fileUploaded(up, file,resp){
          me.importSuccessCallback(resp,file,up);
        },
        filesAdded:function(up){
        }
      }
      PF.initPupload(cfg,fn,function(up){
        me.uploader=up;
        up.bind('FilesAdded', function(up, files) {
          up.setOption("multipart_params",{
            applicationId:me.applicationId,
            businessId:me.businessId,
            formId:me.formId,
            tempBusinessId:me.tempBusinessId,
            fullPath:'y',
            type:me.fileType
          });
          up.start();
        });
      });
    },
    rename(row,index){
      if(!row.name) {
        this.$message.error($lang('文件名不能为空'));
        return;
      }
      let params={
        attachId:row.id,
        name:row.name,
        businessId:this.businessId,
        formId:this.formId,
        tempBusinessId:this.tempBusinessId,
      }
      this.mwApi.business.updateAttachment(params).then(r => {
        this.listAttachment();
      })
    },
    initUploader(){
      let me=this;
      $.each($("button[id^='uploader_']"),function () {
        var buttonId = $(this).attr("id");
        var fjid = buttonId.substring('uploader_'.length)
        if(me.initAttachUploadedId.indexOf(buttonId) != -1) return;
        me.initAttachUploadedId.push(buttonId)
        let cfg={
          buttonId:buttonId,
          maxSize:500,
          multi:false,
          action:me.uploadUrl
        }
        let fn={
          fileUploaded(up, file,resp){
            me.importSuccessCallback(resp,file,up);
          },
          filesAdded:function(up){
          }
        }
        PF.initPupload(cfg,fn,function(up){
          me.uploader=up;
          up.bind('FilesAdded', function(up, files) {
            up.setOption("multipart_params",{
              applicationId:me.applicationId,
              businessId:me.businessId,
              formId:me.formId,
              tempBusinessId:me.tempBusinessId,
              id:fjid,
              fullPath:'y',
              type:me.type
            });
            up.start();
          });
        });
      })
    },
    up(row){
        this.attchId=row.id;
        this.type=row.type;
    },
     action({
      applicationId,
      businessId,
      moduleId,
      formEntityKey,
      tempBusinessId
    }) {
      this.businessId = businessId;
      this.applicationId = applicationId;
      this.moduleId = moduleId;
      this.formId = formEntityKey;
      this.tempBusinessId = tempBusinessId;
      this.listAttachment();
    },
    async listAttachment() {
      const defaultResult = [];
      const {
        result = defaultResult
      } = await this.mwApi.business.listAttachment({
        businessId: this.businessId,
        formId: this.formId,
        //type:'JOA_FJ,JOA_ZW,JOA_CG,JOA_CLD'
      });
      this.attachmentList = result.map(x => {
        return {
          ...x,
          payload: {
            businessId: this.businessId,
            formId: this.formId,
            attachId: x.id
          },
          size: x.size ? (x.size / 1024).toFixed(2) + "K" : ""
        };
      });
      this.$nextTick(function() {
        this.initUploader();
      })
    },
    deleteFile({ id }){
      var params = {
        businessId: this.businessId,
        formId: this.formId,
        tempBusinessId: this.tempBusinessId,
        attachIds:[id]
      }
      PF.confirm("确定删除？").then(()=> {
        this.mwApi.business.deleteAttachment(params).then(() => {
          this.listAttachment();
        });
      })
    },
    download({ id }) {
      PF.downloadAttachment("/api/business/downloadAttachment",{},false,PF.encode({
        id:id,
        businessId: this.businessId,
        formId: this.formId,
        tempBusinessId: this.tempBusinessId
      }))
    },
    importSuccessCallback(resp,file,up){
      if (resp && resp.success) {
      //  this.progressText = "✓"; // &#10003;
        this.$emit("updateTable");
        this.listAttachment();
      } else {
        //this.progressText = "⚠"; // &#9888;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/editAttachment.vue